<div class="content" [ngClass]="{ active: active }" (click)="onClick()">
  <div class="title">
    <ng-content select="[title]"></ng-content>
  </div>

  <div class="description">
    <ng-content select="[description]"></ng-content>
  </div>
</div>
